import React, { useMemo } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createBrowserHistory as createHistory } from "history";
import { QueryClient, QueryClientProvider } from "react-query";
import { SnackbarProvider } from "notistack";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import { useHubSnackBar } from "./hooks/useSnackBar";
import createStore from "./redux/createStore";
import IpcThemeProvider from "./IpcThemeProvider";

import "./utils/utcdayjs";
import { router } from "./router";
import { RouterProvider } from "react-router-dom";

const container = document.getElementById("root");

const HubQueryClientProvider = ({ children }) => {
  const { addSnackbarError } = useHubSnackBar();

  const HubQueryClient = useMemo(
    () =>
      new QueryClient({
        defaultOptions: {
          mutations: {
            onError: (error) => {
              addSnackbarError({ error });
            },
          },
          queries: {
            refetchOnWindowFocus: false,
            retry: false,
          },
        },
      }),
    // eslint-disable-next-line
    []
  );

  return (
    <QueryClientProvider client={HubQueryClient}>
      {children}
    </QueryClientProvider>
  );
};

const history = createHistory();
const store = createStore(history, {});

ReactDOM.render(
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <Provider store={store}>
      <IpcThemeProvider>
        <SnackbarProvider
          maxSnack={1}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <HubQueryClientProvider>
            <RouterProvider router={router} />
          </HubQueryClientProvider>
        </SnackbarProvider>
      </IpcThemeProvider>
    </Provider>
  </LocalizationProvider>,
  container
);
